import { OfficerTitleType } from './OfficerTitleType';

export const OfficerTitleTypeOptions = [
    {
        id: OfficerTitleType.CEO,
        text: 'CEO',
    },
    {
        id: OfficerTitleType.President,
        text: 'President',
    },
    {
        id: OfficerTitleType.CFO,
        text: 'CFO',
    },
    {
        id: OfficerTitleType.Treasurer,
        text: 'Treasurer',
    },
    {
        id: OfficerTitleType.VicePresident,
        text: 'Vice President',
    },
    {
        id: OfficerTitleType.Secretary,
        text: 'Secretary',
    },
    {
        id: OfficerTitleType.Other,
        text: 'Other',
    },
];
